module.exports = __webpack_public_path__ + "media/smartScripting_R2_1.99964018.mp4";